import { Stack, Typography } from "@mui/material";
import useIsCreate from "hooks/useIsCreate";

const Header = () => {
  const isCreate = useIsCreate();
  return (
    <Stack
      spacing={2.5}
      direction='row'
      justifyContent='space-between'>
      <Typography variant='h28'>{isCreate ? "Создание вопроса" : "Редактирование вопроса"}</Typography>
    </Stack>
  );
};

export default Header;
